import React, {useState} from 'react';
import Layout from "../components/Layout/Layout";
import {useNavigate} from "react-router-dom";
import useAuthCalls from "../utilities/custom-hooks/auth-calls";
import {doPostAskResetPassword, doPostResetCode, doPostResetPassword} from "../logic/auth";
import AskResetForm from "../components/Forgotten/AskResetForm";
import CodeVerification from "../components/Forgotten/CodeVerification";
import ErrorMessage from "../components/UI/ErrorMessage";
import NewPassword from "../components/Forgotten/NewPassword";

const Forgotten = () => {

    const navigate = useNavigate();
    const {call} = useAuthCalls();

    const [emailWithCodeSent, setEmailWithCodeSent] = useState(false);
    const [codeVerified, setCodeVerified] = useState(false);
    const [successfulReset, setSuccessfulReset] = useState(false);
    const [error, setError] = useState("");
    const [token, setToken] = useState("");

    const handleSubmit = async (email) => {
        await call(
            () => doPostAskResetPassword(email),
            (res) => {
                console.log(res);
                setEmailWithCodeSent(true);
            },
            (err) => console.log(err)
        );
    }

    const handleCodeVerification = async (code) => {
        setError("");
        await call(
            () => doPostResetCode(code.toLowerCase()),
            (response) => {
                if (response.status && response.status === "ko") {
                    if (response.message)
                        setError(response.message);
                    return;
                }


                if (response && response.length > 0) {
                    let res = response[0];

                    if (res.status === "ok") {
                        setCodeVerified(true);
                        if(res.reset_token) {
                            setToken(res.reset_token);
                        }
                    } else {
                        setError("Qualcosa è andato storto");
                    }
                }
            },
            (err) => {
                if (err && err.message) {
                    setError(err.message);
                }
            }
        );
    }

    const handlePasswordSubmit = async (password) => {
        setError("");
        await call(
            () => doPostResetPassword(token, password),
            (res) => {
                if(res) {
                    if(res.status === "ok") {
                        setSuccessfulReset(true);
                    } else {
                        setError("Qualcosa è andato storto");
                    }
                }
            },
            (err) => {
                if(err.message) {
                    setError(err.message);
                }
            }
        );
    }

    const goToLogin = () => {
        navigate('../login');
    }

    return (
        <Layout current={'/app/forgotten'}>
            <div className="flex flex-col items-center bg-ea_gray_dark flex-1 w-full min-h-screen text-white">
                <div className="mt-8">
                    <div className="text-xl font-medium">Password dimenticata?</div>
                    {error && <ErrorMessage>{error}</ErrorMessage>}

                    {emailWithCodeSent ?
                        codeVerified ?
                            <NewPassword onSubmit={handlePasswordSubmit}
                                         onError={setError}
                                         success={successfulReset}/>
                            :
                            <CodeVerification onSubmit={handleCodeVerification}
                                              onError={setError}
                                              onBack={() => setEmailWithCodeSent(false)}/>
                        :
                        <AskResetForm onSubmit={handleSubmit}/>
                    }


                    <div className="cursor-pointer hover:underline text-sm mt-2 text-white" onClick={goToLogin}>Torna al
                        login
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Forgotten;